import { useEffect, useState } from "react";

import { useSnackbar } from "notistack";

import { MenuFilho } from "../../typesSite/menuFilho/MenuFilho";
import { useGetMenuFilhosQuery } from "../site/features/menus/menufilho/menuFilhoApiSlice";


type Props = {
  inputValue: string;
  handleSetLoad: (newValue: boolean) => void;
};

const useMenuFilhoSiteFetch = ({ inputValue, handleSetLoad }: Props) => {
  const [options, setOptions] = useState<MenuFilho[]>([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  if (handleSetLoad) {
    handleSetLoad(true);
  }
  const { data, isFetching, error } = useGetMenuFilhosQuery({
    search: inputValue,
  });

  useEffect(() => {
    if (data) {
      setOptions(data);
    }

    if (error) {
      let msgBox: string = "";
      if ("status" in error) {
        if (error.status == "FETCH_ERROR") {
          msgBox +=
            "Erro de conexão ao solicitar o serviço! Verifique sua internet. FETCH_ERROR ";
        } else {
          msgBox += "Erro ao buscar os dados:  " + error.status;
        }
      } else {
        msgBox += "Erro encontrado:" + error;
      }
      enqueueSnackbar(msgBox, { variant: "error" });
    }
  }, [isFetching, error]);

  if (handleSetLoad) {
    handleSetLoad(false);
  }

  return { options };
};

export default useMenuFilhoSiteFetch;
